module.exports = __webpack_public_path__ + "img/emp-not-invited-learn-more.4e24361f.webp";